import { render, staticRenderFns } from "./BsIcon.vue?vue&type=template&id=342160aa&"
import script from "./BsIcon.vue?vue&type=script&lang=js&"
export * from "./BsIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports